const utils = require("Sources/utils/utils");
const ModalDialog = require("Sources/utils/modal");
const StorageController = require("Sources/services/storage-controller");
const Shared = require("Sources/shared");

var loginManager = {};

(function(LoginManager)
{
  LoginManager.logout = function(callback)
  {
    $.ajax({
      url: "/logout",
      type: "GET",
      cache: false
    })
    .always(function()
    {
      StorageController.removeFromLocal(StorageController.keys.LOGGED_IN_USER);

      if(utils.isFunction(callback))
      {
        callback();
      }
    });
  };

  LoginManager.login = function(username, password, successCb, failCb)
  {
    LoginManager.logout(function()
    {
      _login(username, password, successCb, failCb);
    })
  };

  function _login(username, password, successCb, failCb)
  {
    $("html").addClass("waiting");

    StorageController.removeFromLocal(StorageController.keys.LOGGED_IN_USER);

    $.ajax({
      url: "/access/authenticate/password",
      type: "POST",
      cache: false,
      dataType: "text",
      // dataType: "xml",
      data: {
        username: utils.isDefined(username) ? username : null,
        password: utils.isDefined(password) ? password : null
      }
    })
    .done(function (data, textStatus, jqXHR)
    {
      var xmlDoc = $($.parseXML(data));
      var referrer = xmlDoc.find("access-control").attr("referer");
      var xmlData = xmlDoc.find("access-control").find("data").text();

      utils.devLog("Login xml data: %s", xmlData);

      $("html").removeClass("waiting");

      if(isSuccess(xmlDoc))
      {
        xmlData = utils.parseJSON(xmlData, true);

        if(utils.isNotNull(xmlData))
        {
          xmlData = xmlData.result;
        }
        else
        {
          console.error("User data is empty in login response");
          return;
        }

        if(xmlData.authenticated)
        {
          if(referrer.includes("/login", 0))
          {
            referrer = "/";
          }

          if(utils.isFunction(successCb))
          {
            successCb(referrer, xmlData);
          }
        }
        else
        {
          // login failed (wrong credentials)
          if(utils.isFunction(failCb))
          {
            failCb();
          }
        }
      }
      else if(isError(xmlDoc))
      {
        var errorData = utils.parseJSON(xmlData, true);

        if(utils.isNotNull(errorData) && utils.isNotNull(errorData.incomplete) && errorData.incomplete)
        {
          ModalDialog.showMessageDialog("login_page.incomplete_profile.dialog.title", "login_page.incomplete_profile.dialog.message", null, true);
        }
        else if(utils.isFunction(failCb))
        {
          failCb();
        }
      }
      else if(utils.isFunction(failCb))
      {
        // always fun to say: should not come here... :)
        failCb();
      }
    })
    .fail(function(data)
    {
      // error in authenticate call
      console.log(data);
      $("html").removeClass("waiting");

      if(typeof failCb === "function")
      {
        failCb();
      }
    });
  }

  function is(what, xml)
  {
    return xml.find("access-control").attr("result") === what;
  }

  function isSuccess (xml)
  {
    return is("success", xml);
  }

  function isError (xml)
  {
    return is("error", xml);
  }

  LoginManager.isLoggedIn = function(callback)
  {
    $.ajax({
      url: "/access/authorize/principal",
      type: "GET",
      cache: false,
    })
    .done(function(data)
    {
      var xmlDoc = $(data);

      var userData;

      if(utils.stringToBoolean(xmlDoc.find("access-control").attr("result")) === true)
      {
        var xmlData = xmlDoc.find("access-control").find("data").text();

        xmlData = utils.parseJSON(xmlData, true);

        if(utils.isNotNull(xmlData))
        {
          userData = xmlData.result;
        }
      }

      if(utils.isFunction(callback))
      {
        callback(userData);
      }
    })
    .fail(function(data)
    {
      if(utils.isFunction(callback))
      {
        callback(null);
      }
    });
  };
}(loginManager));

module.exports = loginManager;



// WEBPACK FOOTER //
// ./app/js/services/login-manager.js